import './LanguageModal.scss';
import {useEffect, useState} from "react";
import api from "utils/api";
import CommonModal from 'components/CommonModal/CommonModal';
import { convertLanguageArray } from 'hooks/useLanguages';
import Button from 'components/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import {useCommonStore} from "../../hooks/useCommonStore";
import {useIntl} from 'react-intl';

const LanguageModal = ({isModalOpen, closeModal, handleSelect, scheduledExamId}) => {
  const {startLoading, stopLoading} = useCommonStore();
  const intl = useIntl();

  const [langOptions, setLangOptions] = useState([]);
  const [selectedLang, setSelectedLang] = useState('');

  const onSelect = () => {
    handleSelect(selectedLang);
  };

  useEffect(() => {
    setSelectedLang('');
    const getLangOptions = async() => {
      const languages = await api.get(`/v1/exam/scheduled/${scheduledExamId}/support-languages`);
      setLangOptions(convertLanguageArray(languages));
      stopLoading();
    }

    if (isModalOpen === true && !!scheduledExamId) {
      startLoading();
      getLangOptions();
    }
  }, [isModalOpen]);

  const isClickedLang = (option) => {
    return option.value === selectedLang;
  }

  return (
    <CommonModal
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      className='LanguageModal'
      title={intl.formatMessage({id: '@exam_main_lang_select'})}
    >
      {
        langOptions.map((option, i) => (
          <div
            className={isClickedLang(option)? 'option clicked' : 'option'}
            key={i}
            onClick={() => setSelectedLang(option.value)}
          >
            {option.name}
            <FontAwesomeIcon
              icon={faCheck}
            />
          </div>
        ))
      }
      <div style={{textAlign: 'center'}}>
        <Button
          color={'primary'}
          style={{fontSize: '18px'}}
          onClick={() => onSelect()}
        >
          {intl.formatMessage({id: '@exam_login_confirm_btn'})}
        </Button>
      </div>

    </CommonModal>
  );
}

export default LanguageModal;
